import opcascader from "./OpCascader/index.js";
import opselect from "./OpSelect/index.js";
import opfilter from "./OpFilter/index.js";
import querytemplate from "./QueryTemplate/index.js";
import opvaluerange from "./OpValueRange/index.js";
import opsearchtree from "./OpSearchTree/index.js";
import opsearchtable from "./OpSearchTable/index.js";
import oporderby from "./OpOrderBy/index.js";
import opshowtablerow from "./OpShowTableRow/index.js";
import optablecontentfilter from "./OpTableContentFilter/index.js";
import pdmUserNameSelect from "./PdmUserNameSelect/index.js";
import opinput from "./OpInput/index.js";
export default {
  opcascader: opcascader,
  opselect: opselect,
  querytemplate: querytemplate,
  opfilter: opfilter,
  opsearchtree: opsearchtree,
  opsearchtable: opsearchtable,
  opvaluerange: opvaluerange,
  oporderby: oporderby,
  opshowtablerow: opshowtablerow,
  optablecontentfilter: optablecontentfilter,
  pdmUserNameSelect: pdmUserNameSelect,
  opinput: opinput
};